<template>
  <div class="index">
    <div class="headers">
      <div>
        <div class="hello">HI 见到你真好！</div>
        <div class="btnBlock">
          <div class="btns">
            <div class="btn" @click="goInvite(1)">邀请车主</div>
            <div class="btn" @click="goInvite(2)">邀请租客</div>
          </div>
          <div class="btns">
            <div class="addCarbtn btn" @click="goAddcar()">添加车辆</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="ProfitCon">
        <div class="item" @click="goIncomedetail(1)">
          <label class="bold">{{totalAccount}}</label>
          <label>累计收益</label>
        </div>
        <div class="item">
          <label class="bold">{{carNum}}</label>
          <label>车辆总数</label>
        </div>
      </div>
      <div class="enter" @click="goapplylist">
        <div class="left">
          <img class="ico" src="@/assets/images/invite/record_icon.png"/>
          <span>上线申请记录</span>
        </div>
        <div class="right"></div>
      </div>
      <div class="vehicleCon">
        <scroll v-if="carList.length>0" class="list orderList" :data="carList" :pulldown="true" @onPullDownRefresh="onPullDownRefresh" :pullup="true" @onPullUp="lower">
          <div class="listwrap">
            <div class="itemBlock" v-for="(item,index) in carList" :key="index">
              <div class="CarCon"><!--  v-if="item.Status==5 || item.Status==6"  -->
                <div class="top">
                  <div class="status">分成</div>
                </div>
                <div class="middle">
                  <div class="left">
                    <img class="carImg" :src="item.ImgUrl || defaultCarImg"/>
                    <div class="carinfo">
                      <span class="carname">{{ item.CarClass }}</span>
                      <span>{{ item.CarNumber }}</span>
                    </div>
                  </div>
                  <div class="right">
                    <span class="carStatus">{{ item.StatusText }}</span>
                    <span>{{ item.City }}</span>
                  </div>
                </div>
                <div class="bottom">
                  <div class="vo" @click="goOrderList(item.CarID)">
                    <span>车辆订单</span>
                  </div>
                  <div class="vo" @click="goSetting(item.ID)">
                    <span>车辆管家</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="lowerdata" v-if=" pageIndex == total_page && carList.length > 2">没有更多了~</div>
          </div>
        </scroll>
        <div class="nodata" v-else>您还没有车辆，立即添加赚收益~</div>
      </div>
    </div>
  </div>
</template>

<script>
import { gettotalAccount, getOnwerCars } from "@/utils/api";
import scroll from "@/components/scroll.vue";
export default {
  name: "index",
  data: function() {
    return {
      totalAccount: 0,
      carNum: 0,
      pageIndex: 1,
      pagesize: 6,
      total_page: 0,
      defaultCarImg: "/static/images/index/car.png",
      carList: []
    };
  },
  components: { scroll },
  created() {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("cityInfo");
    localStorage.removeItem("addressInfo");
    localStorage.removeItem("memberInfo");
  },
  mounted() {
    this.initTotal();
    this.initCar();
  },
  methods: {
    async initTotal() {
      let res = await gettotalAccount({
        data:{}
      });
      if( res.Code==100 ) {
        this.totalAccount = res.Data;
      }
    },
    async initCar() {

      let res = await getOnwerCars({
        data: {
          page: this.pageIndex,
          pagesize: this.pagesize
        },
        isLoading: true,
        loadContent: "加载中..."
      });
      if (res.Code == 100) {
        // let _carNum = 0;
        for (let i = 0; i < res.Data.Rows.length; i++) {
          // if(res.Data.Rows[i].Remark){
          //   res.Data.Rows[i].Remark = res.Data.Rows[i].Remark.replace(/\s+/g,"");
          //   if( res.Data.Rows[i].CarID>0 ){
          //     _carNum ++;
          //   }
          // }
          this.carNum = res.Data.Total;
          // this.carNum = _carNum;
          switch (res.Data.Rows[i].Status) {
            case 1:
              res.Data.Rows[i].StatusText = "待审核";
              break;
            case 3:
              res.Data.Rows[i].StatusText = "待上线";
              break;
            case 4:
              res.Data.Rows[i].StatusText = "已拒绝";
              break;
            case 5:
              res.Data.Rows[i].StatusText = "待租";
              if( res.Data.Rows[i].AutoStatusName!='' ){
                res.Data.Rows[i].StatusText = res.Data.Rows[i].AutoStatusName;
              }
              break;
            case 6:
              res.Data.Rows[i].StatusText = "已下线";
              break;
            default:
              res.Data.Rows[i].StatusText = "其他";
              break;
          }
          if(res.Data.Rows[i].Status==5||res.Data.Rows[i].Status==6){
            this.carList.push(res.Data.Rows[i]);
          }
        }
        this.carNum = this.carList.length;
        this.total_page = Math.ceil(this.carNum / this.pagesize);
      }
    },
    onPullDownRefresh() {
      this.pageIndex = 1;
      this.carList = [];
      this.initCar();

    },
    //上拉加载
    lower() {
      if(this.pageIndex < this.total_page) {
        this.pageIndex += 1;
        this.initCar();
      }
    },
    goIncomedetail() {
      this.$router.replace({ path: "/profitDetail" });
    },
    goSetting(ID) {
      this.$router.replace({ path: "/carSetting", query: { ID: ID } });
    },
    goOrderList(CarID) {
      this.$router.replace({ path: "/orderList", query: { CarID: CarID } });
    },
    goAddcar(vo) {
      let userInfo = {};
      if (vo) {
        userInfo = vo;
      }
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      console.log(userInfo);
      this.$router.replace({ path: "/addCar" });
    },
    goInvite(type) {
      this.$router.replace({ path: "/invite", query: { type: type } });
    },
    goapplylist(){
      this.$router.replace({ path: "/applylist" });
    }
  }
};
</script>
<style scoped lang="scss" type="text/scss">
.index {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 110px 0 35px;
  font-size: 26px;
  box-sizing: border-box;
  background: url("~@/assets/images/user/userBg.png") no-repeat 0 0 #fff;
  background-size: 100% 270px;
  .headers {
    padding: 0px 44px 55px 44px;
    height: 83px;
    > div {
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      .hello {
        color: #fff;
        font-size: 32px;
      }
      .btnBlock{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .btns {
          display: flex;
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            font-size: 22px;
            width: 142px;
            height: 52px;
            background: #ffd500;
            border-radius: 26px;
            &:last-child{
              margin: 0px;
            }
          }
          .addCarbtn{
            background: #fff;
          }
        }
      }
    }
  }
  .content {
    width: 100%;
    padding: 0 32px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 20px 20px 0px 0px;
    .ProfitCon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      height: 200px;
      .item {
        display: flex;
        flex-direction: column;
        width: 375px;
        color: #9f9f9f;
        &:first-child {
          border-right: 1px solid #e7e6e6;/*no*/
        }
        .bold {
          color: #027fff;
          font-size: 46px;
        }
      }
    }
    .enter{
      width:100%;
      height: 70px;
      border-radius: 35px;
      padding:0 28px;
      box-sizing:border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background:rgba(255,213,0,0.3);
      border:2px solid rgba(255,213,0,1);
      margin-bottom:40px;
      .left{
        height: 40px;
        line-height: 40px;
        display: flex;
        align-items: center;
        img{
          width:40px;
        }
        span{
          color:#FF572C;
          font-size: 24px;
          vertical-align: middle;
        }
      }
      .right{
        width: 17px;
        height: 17px;
        border-top: 2px solid #FF572C;
        border-right: 2px solid #FF572C;
        transform: rotate(45deg);
      }

    }
    .vehicleCon {
      margin-bottom: 40px;
      .list {
        flex: 1;
        width: 100%;
        height: 650px;
        overflow: scroll;
        padding: 10px;
        box-sizing: border-box;
        .carBlock {
          padding: 25px 23px;
          margin-bottom: 20px;
          box-sizing: border-box;
          box-shadow: 0 0 6px #ccc;
          -webkit-box-shadow: 0 0 6px #ccc;
          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
              display: flex;
              .carImg {
                width: 185px;
                height: 104px;
              }
              .carinfo {
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                color: #9f9f9f;
                .carname {
                  margin-bottom: 10px;
                  font-size: 34px;
                  font-weight: bold;
                  color: #000;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 300px;
                  overflow: hidden;
                }
              }
            }
            .right {
              display: flex;
              flex-direction: column;
              text-align: right;
              color: #9f9f9f;
              height: 90px;
              .carStatus {
                margin-bottom: 10px;
                color: #ff572c;
                font-weight: bold;
              }
            }
          }
          .bottom {
            display: flex;
            margin-top: 10px;
            margin-left: 10px;
            .remark {
              width: 100%;
            }
            color: #9f9f9f;
          }
        }
        .CarCon {
            padding: 0 31px;
            box-sizing: border-box;
            // border: 1px solid #ffd500;/*no*/
            border: 1px solid #027FFF;/*no*/
            margin-bottom: 40px;
            .top {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .status {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 145px;
                height: 57px;
                background: #ffd500;
                border-radius: 0px 0px 10px 10px;
              }
            }
            .middle {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 40px 0 23px;
              box-sizing: border-box;
              border-bottom: 1px solid #dcdcdc;/*no*/
              .left {
                display: flex;
                .carImg {
                  width: 185px;
                  height: 104px;
                }
                .carinfo {
                  display: flex;
                  flex-direction: column;
                  margin-left: 20px;
                  color: #9f9f9f;
                  .carname {
                    margin-bottom: 10px;
                    font-size: 34px;
                    font-weight: bold;
                    color: #000;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 300px;
                    overflow: hidden;
                  }
                }
              }
              .right {
                display: flex;
                flex-direction: column;
                text-align: right;
                color: #9f9f9f;
                height: 90px;
                .carStatus {
                  margin-bottom: 10px;
                  color: #ff572c;
                  font-weight: bold;
                }
              }
            }
            .bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .vo {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 350px;
                height: 80px;
                &:first-child {
                  border-right: 1px solid #dcdcdc;/*no*/
                  padding-right: 30px;
                }
                &:last-child {
                  padding-left: 30px;
                }
                .value {
                  color: #027fff;
                  font-size: 30px;
                  font-weight: bold;
                }
              }
              .goDetail {
                display: flex;
                justify-content: center;
                width: 350px;
              }
            }
        }

        .lowerdata {
          text-align: center;
          color: #9f9f9f;
        }
      }
      .nodata {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px 0;
        margin-top: 200px;
        box-sizing: border-box;
        color: #9f9f9f;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue